import api from "./client"
import type { User } from "../types"

interface AuthResponse {
  message: string
  user: User
}

export async function signIn(
  email: string,
  password: string,
): Promise<{ user: User; token: string }> {
  const response = await api.post<AuthResponse>("/users/sign_in", {
    user: { email, password },
  })
  // Devise JWT dispatches the token in the Authorization header
  const token = response.headers["authorization"]?.replace("Bearer ", "") ?? ""
  return { user: response.data.user, token }
}

export async function signUp(
  name: string,
  email: string,
  password: string,
  passwordConfirmation: string,
): Promise<{ user: User; token: string }> {
  const response = await api.post<AuthResponse>("/users/sign_up", {
    user: { name, email, password, password_confirmation: passwordConfirmation, role: "trainer" },
  })
  const token = response.headers["authorization"]?.replace("Bearer ", "") ?? ""
  return { user: response.data.user, token }
}

export async function signOut(): Promise<void> {
  await api.delete("/users/sign_out")
}

export async function forgotPassword(email: string): Promise<void> {
  await api.post("/users/password", { user: { email } })
}

export async function resetPassword(
  resetPasswordToken: string,
  password: string,
  passwordConfirmation: string,
): Promise<void> {
  await api.put("/users/password", {
    user: {
      reset_password_token: resetPasswordToken,
      password,
      password_confirmation: passwordConfirmation,
    },
  })
}

export async function changePassword(
  currentPassword: string,
  password: string,
  passwordConfirmation: string,
): Promise<string> {
  const response = await api.put<{ message: string }>("/users/password", {
    current_password: currentPassword,
    password,
    password_confirmation: passwordConfirmation,
  })
  return response.data.message
}
